export default "__VITE_ASSET__D9D4L6b9__"